import { SORT_OPTIONS } from "@/utils/applicationConstants";
import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_LOAN_STATUSES } from "@/redux/constants/loan_statuses";

const DEFAULT_FILTERS = { page: 1, size: 30, sortBy: SORT_OPTIONS[0].id, searchTerm: "" };

const getLoanStatuses = sharedService.injectEndpoints({
  endpoints: builder => ({
    getLoanStatuses: builder.query({
      query: () => {
        const params = new URLSearchParams();
        Object.entries(DEFAULT_FILTERS).forEach(([k, v]) => { if (v) params.set(k, v); });
        return `parameters/loan-statuses?${params}`;
      },
      transformResponse: response => response.items,
      providesTags: ["LoanStatuses"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_LOAN_STATUSES, loanStatuses: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetLoanStatusesQuery } = getLoanStatuses;

